// Unique item catalogue. docs/04-equipment-craft §4.4 / docs/adr/0022-unique-items.md.
//
// ADR 0022 Scope A: 型 + 機構 + 代表サンプル 8 個。各 `UniqueItemDefinition` は固定
// ベース + 固有 affix 3 個 (72-pool 参照 + 固定 Tier) + 固有スキル (item.unique.*)。
// drop 時に affix 値と itemSkill tier が抽選され個体差が出る (loot.ts unique 分岐)。
//
// ID 規約: `unique.<themeId>` (themeId は unique itemSkill のテーマと一致)。
// 全 89 テーマの authoring は別 ADR (full-population)。数値・組合せは暫定 (Phase 4 校正)。
/** 代表サンプル 8 個 (7 slot をカバー)。ADR 0022 §D4 確定表。 */
export const UNIQUE_ITEMS = [
    {
        id: 'unique.juggernaut',
        name: '巨躯の覇者',
        baseId: 'base.weaponMain.sword.5',
        affixes: [
            { affixId: 'affix.prefix.damage.physical', tier: 5 },
            { affixId: 'affix.prefix.offense.crit_damage', tier: 4 },
            { affixId: 'affix.prefix.conditional.execute_damage', tier: 5 },
        ],
        itemSkillIds: ['item.unique.juggernaut.vanilla-amp'],
    },
    {
        id: 'unique.ironwall',
        name: '鉄壁の守護',
        baseId: 'base.offHand.shield.4',
        affixes: [
            { affixId: 'affix.suffix.defense.armor_pct', tier: 5 },
            { affixId: 'affix.suffix.utility.block_chance', tier: 5 },
            { affixId: 'affix.suffix.status.resist_paralyze', tier: 4 },
        ],
        itemSkillIds: ['item.unique.ironwall.shield-double'],
    },
    {
        id: 'unique.berserker',
        name: '狂戦士の渇望',
        baseId: 'base.weaponMain.axe.5',
        affixes: [
            { affixId: 'affix.prefix.damage.fire', tier: 5 },
            { affixId: 'affix.prefix.offense.attack_speed', tier: 4 },
            { affixId: 'affix.prefix.proc.bleed_chance', tier: 5 },
        ],
        itemSkillIds: ['item.unique.berserker.hp-cost-amp', 'item.unique.berserker.kill-frenzy'],
    },
    {
        id: 'unique.executioner',
        name: '処刑人の刻印',
        baseId: 'base.head.helmet.4',
        affixes: [
            { affixId: 'affix.prefix.offense.crit_chance', tier: 4 },
            { affixId: 'affix.suffix.defense.max_hp', tier: 4 },
            { affixId: 'affix.suffix.status.resist_all', tier: 3 },
        ],
        itemSkillIds: ['item.unique.executioner.hp30-burst', 'item.unique.executioner.true-finisher'],
    },
    {
        id: 'unique.crimson-thirst',
        name: '紅蓮の渇き',
        baseId: 'base.chest.chest.4',
        affixes: [
            { affixId: 'affix.suffix.defense.armor_pct', tier: 4 },
            { affixId: 'affix.suffix.sustain.hp_regen', tier: 4 },
            { affixId: 'affix.suffix.status.resist_burn', tier: 4 },
        ],
        itemSkillIds: ['item.unique.crimson-thirst.bloodlust'],
    },
    {
        id: 'unique.frost-shroud',
        name: '氷結の帳',
        baseId: 'base.boots.boots.3',
        affixes: [
            { affixId: 'affix.suffix.defense.max_hp', tier: 3 },
            { affixId: 'affix.suffix.utility.move_speed', tier: 3 },
            { affixId: 'affix.suffix.status.resist_freeze', tier: 3 },
        ],
        itemSkillIds: ['item.unique.frost-shroud.shatter'],
    },
    {
        id: 'unique.assassin-cloak',
        name: '暗殺者の外套',
        baseId: 'base.cloak.cloak.4',
        affixes: [
            { affixId: 'affix.prefix.offense.cooldown_rate', tier: 4 },
            { affixId: 'affix.suffix.utility.dodge', tier: 4 },
            { affixId: 'affix.suffix.defense.all_resist', tier: 3 },
        ],
        itemSkillIds: ['item.unique.assassin-cloak.backstab-amp'],
    },
    {
        id: 'unique.guardian-oath',
        name: '守護者の誓い',
        baseId: 'base.amulet.amulet.5',
        affixes: [
            { affixId: 'affix.suffix.defense.max_hp', tier: 5 },
            { affixId: 'affix.suffix.status.resist_all', tier: 4 },
            { affixId: 'affix.suffix.support.healing_power', tier: 5 },
        ],
        itemSkillIds: ['item.unique.guardian-oath.tank-reflect'],
    },
];
//# sourceMappingURL=unique-items.js.map